import React from 'react';
import PageHeading from "../../../../Components/PageHeading";
import {useNavigate} from "react-router-dom";
import {configureItem} from "../../../../layout/ExtraMenuItem";


const Configuration = () => {


    const navigate = useNavigate();
    return (
        <div className={"card"}>
            <PageHeading title={"Configuration"}/>

            <div className={""}>
                <div className={"flex flex-column gap-4"}>
                    {
                        configureItem?.map((setting, index) => {
                            return (
                                <div className={"flex flex-column gap-4"} key={index}>
                                    <h6 className="m-0 font-semibold text-lg">{setting?.title}</h6>
                                    <div className={"grid "}>
                                        {
                                            setting?.settingsList?.map((settingItem, idx) => {
                                                return (
                                                    <div key={idx} className="col-6 md:col-4 lg:col-2">
                                                        <div
                                                            onClick={() => navigate(settingItem?.navigateTo)}
                                                            className="group flex flex-column gap-2 justify-content-center align-items-center cursor-pointer p-2 border-round hover:surface-100 transition-colors transition-duration-200"
                                                        >
                                                            <div>
                                                                <img
                                                                    src={settingItem?.icon}
                                                                    alt={settingItem?.name}
                                                                    className="w-5rem h-5rem object-contain"
                                                                />
                                                            </div>
                                                            <div className="text-center">
                                                                <a className="text-sm font-semibold text-700 group-hover:text-blue-500 transition-colors">
                                                                    {settingItem?.name}
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    );
};

export default Configuration;
